import * as React from "react";
import { Badge } from "@fluentui/react-components";

const CounterBadges = (props) => {
  const { StyleClass, BadeIcon, BadgeSize, count=0 } = props;

  return (
    <>
    {
      count > 0 && (
        <Badge
        className={`${StyleClass} CounterBadgeWrap`}
        appearance="filled"
        size={BadgeSize}
        shape="circular"
        icon={BadeIcon}
      >
        {count <= 9 ? count : '9+'}
      </Badge>
      )
    }
    </>
  );
};

export default CounterBadges;
